// The four hero sources below are emitted by the ai_coding_2026q3_loswp_pick_mobile treatment
// arm. A source name never identifies the arm; every readout must join on the test's bucketing.
// The tabs-hero prefix is deliberate, not stale: pick_download renders no tabs, but it shares the
// loswp-tabs-hero checkout trigger (checkoutOpts.ts), which branches server-side in
// registrations_controller and is named in the pre-registered primary metric. Renaming these
// without renaming that trigger would split one journey across two vocabularies.
// TAB_PACK_CLICK_SOURCE and TAB_PDF_CLICK_SOURCE are the exception: tabs_thumbnail only.
export const PACK_CLICK_SOURCE = 'loswp--tabs-hero-pack--hero';
export const PDF_CLICK_SOURCE = 'loswp--tabs-hero-pdf--hero';
export const IMPRESSION_SOURCE = 'loswp--tabs-hero--impression';
export const THUMBNAIL_CLICK_SOURCE = 'loswp--tabs-hero-pdf--thumbnail';
export const TAB_PACK_CLICK_SOURCE = 'loswp--tabs-hero-pack--tab';
export const TAB_PDF_CLICK_SOURCE = 'loswp--tabs-hero-pdf--tab';
